import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ReportsActions";
import { ImpiantiByModello } from "../generated";
import { InLocalStorage } from "../common/InLocalStorage";

class TopCaldaieReportStore extends AbstractGetAllStore<ImpiantiByModello>{
    constructor() {
        super(x => x.marca! + x.modello!, new InLocalStorage<ImpiantiByModello>("TopCaldaieReport"));
        Dispatcher
            .onfunction(Actions.getTopCaldaieReport, result => this.setAll(result))
            ;
    }
    public useAll = () => this.useAllWithAction(() => Actions.getTopCaldaieReport())
}

export default new TopCaldaieReportStore()
